/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

export const enum MessageBoxVariant {
  Warning = 'WARNING',
  Danger = 'DANGER',
  Success = 'SUCCESS',
  InformativeCloud = 'INFORMATIVE_CLOUD',
  InformativeApi = 'INFORMATIVE_API',
}
